export const WindowsLiveProvider = "windowslive";
export const GoogleOAuth2Provider = "google-oauth2";

export const MaxAllowedFreeCharts = 3;